<div class="be-card">
  @if ((isLoading$ | async) && !(hasError$ | async)) {
    <div
      class="flex-centered spinner-container"
      >
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  }
  @if (isProcessed$ | async) {
    @if (!isEditMode) {
      <app-profile-details
        [entries]="entries"
        (onEdit)="toggleIsEditMode()"
        [modalData]="modalData"
      ></app-profile-details>
    }
    @if (isEditMode && residenceForm) {
      <app-profile-residence-edit
        [residenceForm]="residenceForm"
        [residenceData]="residenceData"
        [ownershipStatuses]="ownershipStatuses"
        (onCancel)="toggleIsEditMode()"
        ></app-profile-residence-edit
        >
      }
    }
  </div>
